import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "device-iphone-x"
  }, [_c('div', {
    staticClass: "device-frame"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "device-stripe"
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-7dfee3d0_0", {
    source: ".device-iphone-x[data-v-7dfee3d0]{background:#222;border-radius:68px;box-shadow:inset 0 0 2px 2px #c8cacb,inset 0 0 0 7px #e2e3e4;padding:28px 26.5px;position:relative;height:868px;width:428px}.device-iphone-x .device-frame[data-v-7dfee3d0]{background:#fff;border-radius:40px;position:relative;height:100%;overflow:hidden;width:100%}.device-iphone-x .device-stripe[data-v-7dfee3d0]::after,.device-iphone-x .device-stripe[data-v-7dfee3d0]::before{border:solid rgba(51,51,51,.25);border-width:0 7px;content:\"\";height:.8%;left:0;position:absolute;width:100%;z-index:9}.device-iphone-x .device-stripe[data-v-7dfee3d0]::after{top:9.7%}.device-iphone-x .device-stripe[data-v-7dfee3d0]::before{bottom:9.7%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-7dfee3d0";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var DeviceIphone = __vue_component__;
export { DeviceIphone as default };